/**
 * @file JS - helper - dictionary.js - Dictionnaire anglais-français
 * @author : Adam Lemire
 * @since 2019/09/12
 * @version 1.1
 * @summary Dernières modifications : 2020/12/02
 */

// properties.groupLabels à enlever

export const dictionary = {
  header: {
    title: {
      en: 'Unsaved project*',
      fr: 'Projet non-enregistré*'
    },
    titleProject: {
      en: 'PROJECT : ',
      fr: 'PROJET : '
    },
    titleMap: {
      en: ' - MAP : ',
      fr: ' - CARTE : '
    },
    menu: {
      en: 'Menu',
      fr: 'Menu'
    },
    newProject: {
      en: 'New Project',
      fr: 'Nouveau Projet'
    },
    openProject: {
      en: 'Open Project...',
      fr: 'Ouvrir Projet...'
    },
    ouvrirProjetChercheur: {
      en: 'Open from researcher folder',
      fr: 'Ouvrir depuis Espace chercheur'
    },
    renameProject: {
      en: 'Rename Project',
      fr: 'Renommer Projet'
    },
    saveProject: {
      en: 'Save Project',
      fr: 'Enregistrer Projet'
    },
    saveProjectAPI: {
      en: 'Save Project',
      fr: 'Enregistrer le projet'
    },
    saveProjectAs: {
      en: 'Save Project As...',
      fr: 'Enregistrer Projet Sous...'
    },
    exportMap: {
      en: 'Export Map',
      fr: 'Exporter Carte'
    },
    importData: {
      en: 'Import local data',
      fr: 'Importer données locales'
    },
    importResearcherData: {
      en: 'Add data selection',
      fr: 'Ajouter une sélection de données'
    },
    save: {
      en: 'Save',
      fr: 'Enregistrer'
    },
    saveAPI: {
      en: 'Save Project',
      fr: 'Enregistrer le projet'
    },
    import: {
      en: 'Import',
      fr: 'Importer'
    },
    addMap: {
      en: 'Add map',
      fr: 'Ajouter carte'
    },
    addMultiMap: {
      en: 'Add comparative map',
      fr: 'Ajouter carte comparative'
    },
    zoomOut: {
      en: 'Zoom-',
      fr: 'Zoom-'
    },
    recenter: {
      en: 'Recenter',
      fr: 'Recentrer'
    },
    zoomIn: {
      en: 'Zoom+',
      fr: 'Zoom+'
    },
    pdf: {
      en: 'PDF',
      fr: 'PDF'
    },
    help: {
      en: 'Help',
      fr: 'Aide'
    },
    language: {
      en: 'FR',
      fr: 'EN'
    }
  },
  leftMenu: {
    mapLayers: {
      en: 'Map Layers',
      fr: 'Couches de la carte'
    },
    webLayers: {
      en: 'Web Layers',
      fr: 'Couches disponibles'
    },
    multiMap: {
      buttonTooltip: {
        en: 'Multiple maps',
        fr: 'Cartes multiples'
      },
      formatLabel: {
        en: 'Format',
        fr: 'Affichage'
      },
      formatHorizontal: {
        en: 'Horizontal',
        fr: 'Horizontal'
      },
      formatVertical: {
        en: 'Vertical',
        fr: 'Vertical'
      },
      formatGrid: {
        en: 'Grid',
        fr: 'Quadrillé'
      },
      formatOverlay: {
        en: 'Overlay',
        fr: 'Superposé'
      },
      selectMapDefaultOption: {
        en: 'Select map',
        fr: 'Choisir carte'
      },
      map1Label: {
        en: 'Map 1',
        fr: 'Carte 1'
      },
      map2Label: {
        en: 'Map 2',
        fr: 'Carte 2'
      },
      map3Label: {
        en: 'Map 3',
        fr: 'Carte 3'
      },
      map4Label: {
        en: 'Map 4',
        fr: 'Carte 4'
      },
      map5Label: {
        en: 'Base map',
        fr: 'Carte de fond'
      },
      map6Label: {
        en: 'Overlay map',
        fr: 'Carte superposée'
      }
    },
    printLayout: {
      buttonTooltip: {
        en: 'Print layout options',
        fr: 'Mise en forme'
      }
    }
  },
  map: {
    opacity: {
      en: 'Opacity',
      fr: 'Opacité'
    }
  },
  contextMenu: {
    properties: {
      en: 'Properties',
      fr: 'Propriétés'
    },
    copy: {
      en: 'Copy',
      fr: 'Copier'
    },
    paste: {
      en: 'Paste',
      fr: 'Coller'
    },
    attributeTable: {
      en: 'Attribute table',
      fr: "Table d'attributs"
    },
    remove: {
      en: 'Remove',
      fr: 'Enlever'
    },
    rename: {
      en: 'Rename',
      fr: 'Renommer'
    },
    duplicate: {
      en: 'Duplicate',
      fr: 'Dupliquer'
    },
    delete: {
      en: 'Delete',
      fr: 'Supprimer'
    }
  },
  button: {
    apply: {
      en: 'Apply',
      fr: 'Appliquer'
    },
    cancel: {
      en: 'Cancel',
      fr: 'Annuler'
    },
    chooseFile: {
      en: 'Choose file',
      fr: 'Choisir le fichier'
    },
    chooseProject: {
      en: 'Choose project',
      fr: 'Choisir le projet'
    },
    open: {
      en: 'Open',
      fr: 'Ouvrir'
    },
    import: {
      en: 'Import',
      fr: 'Importer'
    },
    retry: {
      en: 'Retry',
      fr: 'Réessayer'
    }
  },
  properties: {
    autres: {
      en: 'Show non-imported entities',
      fr: 'Afficher les entitées non-importées'
    },
    categories: {
      en: 'Categorized',
      fr: 'Catégorisé'
    },
    color: {
      en: 'Color',
      fr: 'Couleur'
    },
    colorGradient: {
      en: 'Color gradient',
      fr: 'Gradient de couleur'
    },
    colorTheme: {
      en: 'Color theme',
      fr: 'Thème de couleur'
    },
    counter: {
      en: 'Counter',
      fr: 'Décompte'
    },
    fill: {
      en: 'Fill',
      fr: 'Remplissage'
    },
    formatPoint: {
      en: 'Convert to points',
      fr: 'Convertir en points'
    },
    graduated: {
      en: 'Graduated',
      fr: 'Gradué'
    },
    gradationType: {
      en: 'Gradation type',
      fr: 'Type de gradation'
    },
    group: {
      en: 'Group',
      fr: 'Groupe'
    },
    groupQuantity: {
      en: 'Number of groups',
      fr: 'Nombre de groupes'
    },
    groupClassification: {
      en: 'Classification',
      fr: 'Classification'
    },
    groupValues: {
      en: 'Column (group values)',
      fr: 'Colonne (valeur du groupe)'
    },
    groupLabels: {
      en: 'Column (group label)',
      fr: 'Colonne (étiquette)'
    },
    header: {
      en: ' - Layer properties',
      fr: ' - Propriétés de la couche'
    },
    label: {
      en: 'Label',
      fr: 'Étiquette'
    },
    layerLabel: {
      en: 'Layer name',
      fr: 'Nom de la couche'
    },
    legend: {
      en: 'Legend',
      fr: 'Légende'
    },
    nullValues: {
      en: '* Null values are replaced by zeros.',
      fr: '* Les valeurs nulles sont remplacées par des zéros.'
    },
    opacity: {
      en: 'Opacity',
      fr: 'Opacité'
    },
    precision: {
      en: 'Precision',
      fr: 'Précision'
    },
    preview: {
      en: 'Preview',
      fr: 'Aperçu'
    },
    selectColumn: {
      en: ' -- select column -- ',
      fr: ' -- choisir colonne -- '
    },
    singleSymbol: {
      en: 'Single symbol',
      fr: 'Symbole unique'
    },
    size: {
      en: 'Size',
      fr: 'Taille'
    },
    sourceTitle: {
      en: 'Source',
      fr: 'Source'
    },
    sourceLabel: {
      en: 'Source file',
      fr: 'Fichier source'
    },
    stroke: {
      en: 'Stroke',
      fr: 'Trait'
    },
    styleTitle: {
      en: 'Style',
      fr: 'Style'
    },
    symbol: {
      en: 'Symbol',
      fr: 'Symbole'
    },
    symbolStyle: {
      en: 'Symbol style',
      fr: 'Style du symbole'
    },
    symbolStyleAutres: {
      en: 'Non-imported entities style',
      fr: 'Style des entités non-importées'
    },
    typeLabel: {
      en: 'Type',
      fr: 'Type'
    },
    width: {
      en: 'Width',
      fr: 'Épaisseur'
    }
  },
  classification: {
    eqInterval: {
      en: 'Equal interval',
      fr: 'Intervalles égaux'
    },
    attributeValue: {
      en: 'Attributes value',
      fr: 'Valeur des attributs'
    },
    geometricProgression: {
      en: 'Geometric Interval',
      fr: 'Intervalles géométriques'
    },
    jenks: {
      en: 'Jenks',
      fr: 'Pauses naturelles Jenks'
    },
    quantile: {
      en: 'Quantile',
      fr: 'Quantile'
    },
    stdDeviation: {
      en: 'Standard deviation',
      fr: 'Écart-type'
    },
    stdDeviationLegendArray: {
      en: ['< -2 Std. Dev.', '-2 à -0.5 Std. Dev.', '-0.5 à 0.5 Std. Dev.', '0.5 à 2 Std. Dev.', '> 2 Std. Dev.'],
      fr: ['< -2 écarts-types', '-2 à -0.5 écarts-types', '-0.5 à 0.5 écart-type', '0.5 à 2 écarts-types', '> 2 écarts-types']
    },
    legendSeparator: {
      en: ' to ',
      fr: ' à '
    },
    description: {
      attributeValue: {
        en: 'This classification creates the classes corresponding to the different attribute values of the chosen column.',
        fr: "Cette classification crée les différents groupes correspondants aux différentes valeurs d'attributs de la colonne choisie."
      },
      eqInterval: {
        en: 'The interval used for the creation of the classes is calculated by dividing the amplitude (between the minimum value and the maximum value) by the number of classes chosen.<br>This method is suitable when the data values ​​are distributed evenly over the entire amplitude of the series, and it is unsuitable if the extreme values ​​deviate from the series. For more informations : <a href="http://wiki.gis.com/wiki/index.php/Equal_Interval_classification#Equal_Interval_classification" target="_blank" rel="noopener noreferrer">http://wiki.gis.com/wiki/index.php/Equal_Interval_classification</a>.',
        fr: "L'intervalle utilisé pour la création des groupes est calculé en divisant l'amplitude (entre la valeur minimale et la valeur maximale) par le nombre de groupes choisi.<br>Cette méthode est adaptée lorsque les valeurs des données sont réparties uniformément sur toute l'amplitude de la série, et elle est inadaptée si les valeurs extrêmes s'écartent de la série."
      },
      geometricProgression: {
        en: 'This classification method is used for visualizing continuous data that is not distributed normally. This method was designed to work on data that contains excessive duplicate values, e.g., 35% of the features have the same value. <b>Please note, depending on the data distribution and the number of classes desired, some classes may be doubled:</b> in this case, you must either reduce the number of classes or change the classification method.',
        fr: 'Cette méthode de classification est utilisée pour visualiser des données continues qui ne sont pas distribuées normalement. Cette méthode a été conçue pour fonctionner sur des données qui contiennent des valeurs en double excessives, par exemple, 35% des caractéristiques ont la même valeur. <b>Attention, selon la distribution des données et le nombre de groupes désiré, il se peut que des groupes soient doublés:</b> dans ce cas, il faut soit réduire le nombre de groupes, ou changer de méthode de classification. Voir <a href="https://fr.wikipedia.org/wiki/Suite_g%C3%A9om%C3%A9trique" target="_blank" rel="noopener noreferrer">https://fr.wikipedia.org/wiki/Suite_géométrique</a>.'
      },
      jenks: {
        en: 'The Jenks Natural Breaks Classification (or Optimization) system is a data classification method designed to optimize the arrangement of a set of values into "natural" classes. A Natural class is the most optimal class range found "naturally" in a data set. A class range is composed of items with similar characteristics that form a "natural" group within a data set.<br>This classification method seeks to minimize the average deviation from the class mean while maximizing the deviation from the means of the other groups. The method reduces the variance within classes and maximizes the variance between classes. For more informations : <a href="http://wiki.gis.com/wiki/index.php/Jenks_Natural_Breaks_Classification" target="_blank" rel="noopener noreferrer">http://wiki.gis.com/wiki/index.php/Jenks_Natural_Breaks_Classification</a>.',
        fr: 'Cette classification est aussi appelée "ruptures naturelles (Jenks)". Pour chaque classe, les valeurs sont les plus proches possibles (à tendance homogène) et les classes sont les plus éloignées possibles (à tendance hétérogène).<br> Elle donne généralement de bons résultats pour toutes les distributions, mais elle n\'est pas conseillée lorsque la distribution est trop hétérogène.'
      },
      quantile: {
        en: '',
        fr: ''
      },
      stdDeviation: {
        en: "The Standard Deviation Classification method finds the mean value of the observations then places class breaks above and below the mean at intervals of either .5 or 2 standard deviation (fixed in this application for simplicity) until all the data values are contained within the classes. This classification method shows how much the feature's attribute value varies from the mean. Using a diverging color scheme to illustrate these values is useful to emphasize which observations are above the mean and which observations are below the mean.",
        fr: "Chaque groupe est déterminé selon une fraction ou un multiple de l'écart-type par rapport à la moyenne. L'écart-type mesure la dispersion d'une série de valeurs autour de leur moyenne (ici toutes les valeurs).<br>Les groupes sont fixés dans cette application par simplicité d'utilisation.<br>Cette classification convient bien à une distribution symétrique (courbe de Gauss en forme de cloche)."
      }
    }
  },
  color: {
    red: {
      en: 'red',
      fr: 'rouge'
    },
    green: {
      en: 'green',
      fr: 'vert'
    },
    blue: {
      en: 'blue',
      fr: 'bleu'
    },
    light: {
      en: 'light',
      fr: 'clair'
    },
    normal: {
      en: 'normal',
      fr: 'normal'
    },
    dark: {
      en: 'dark',
      fr: 'sombre'
    }
  },
  placeholder: {
    newName: {
      en: 'New name',
      fr: 'Nouveau nom'
    },
    newProjectName: {
      en: 'New project name',
      fr: 'Nouveau nom de projet'
    },
    newMapName: {
      en: 'New map name',
      fr: 'Nouveau nom de carte'
    },
    noFile: {
      en: 'No file',
      fr: 'Aucun fichier'
    },
    noFileSelected: {
      en: 'No file selected',
      fr: 'Aucun fichier choisi'
    },
    text: {
      en: 'Text',
      fr: 'Texte'
    }
  },
  defaultText: {
    projectTitle: {
      en: 'new project',
      fr: 'nouveau projet'
    },
    singleMapName: {
      en: 'new map',
      fr: 'nouvelle carte'
    },
    multiMapName: {
      en: 'multi-maps',
      fr: 'multi-cartes'
    }
  },
  layoutPage: {
    entete: {
      bouton: {
        legende: {
          en: 'Legend',
          fr: 'Légende'
        },
        reinitialiser: {
          en: 'Reset',
          fr: 'Réinitialiser'
        },
        texte: {
          en: 'Text',
          fr: 'Texte'
        }
      }
    },
    editeur: {
      entete: {
        en: 'Layout settings',
        fr: 'Options de mise en forme'
      },
      legende: {
        bordure: {
          en: 'Border',
          fr: 'Bordure'
        },
        taille: {
          en: 'Size',
          fr: 'Taille'
        },
        titre: {
          en: 'Legend',
          fr: 'Légende'
        }
      },
      texte: {
        taille: {
          en: 'Size',
          fr: 'Taille'
        },
        texte: {
          en: 'Text',
          fr: 'Texte'
        },
        titre: {
          en: 'Text ',
          fr: 'Texte '
        },
        transparence: {
          en: 'Transparency',
          fr: 'Transparence'
        }
      }
    }
  },
  importWindow: {
    titre: {
      en: 'Files from researcher folder',
      fr: 'Fichiers de données de l\'espace chercheur'
    }
  },
  modaleAvertissement: {
    attribut: {
      en: 'No attribute selected.',
      fr: 'Aucun attribut choisi.'
    },
    region: {
      en: 'No region selected.',
      fr: 'Aucune région choisie.'
    },
    source: {
      en: 'No source selected.',
      fr: 'Aucune source choisie.'
    },
    sauvegardeOk: {
      en: 'Saved successfully',
      fr: 'Sauvegarde réussie'
    },
    sauvegardeErreur: {
      en: 'Error: ',
      fr: 'Erreur: '
    },
    erreur: {
      en: 'Error',
      fr: 'Erreur'
    }
  }
};

/**
 * @description Ajoute le texte dans le html selon la langue
 * @param {*} lang
 */
export function setText (lang) {
  $('[data-text]').text(function () {
    const key = $(this).data('text');
    return getDictionaryValue(lang, key);
  });
  $('[data-placeholder]').attr('placeholder', function () {
    const key = $(this).data('placeholder');
    return getDictionaryValue(lang, key);
  });
  $('[data-title]').attr('title', function () {
    const key = $(this).data('title');
    return getDictionaryValue(lang, key);
  });
  $('[data-html]').empty().append(function () {
    const key = $(this).data('html');
    return getDictionaryValue(lang, key);
  });
}

/**
 * @description va chercher la valeur dans dictionary
 * @param { string } lang
 * @param { string } key
 * @returns { string }
 */
function getDictionaryValue (lang, key) {
  try {
    const parts = key.split('.');

    switch (parts.length) {
      case 4:
        return dictionary[parts[0]][parts[1]][parts[2]][parts[3]][lang];
      case 3:
        return dictionary[parts[0]][parts[1]][parts[2]][lang];
      case 2:
        return dictionary[parts[0]][parts[1]][lang];
      case 1:
        return dictionary[parts[0]][lang];
      default:
        return key;
    }
  } catch (e) {
    console.log('erreur dictionnaire: ' + key);
  }
}
